import React from 'react';
import { translate } from 'react-i18next';

import * as NotificationConfig from 'notifications_config/components/form';
import * as Common from 'common/components';

const NotificationConfigFormView = ({
  t,
  notificationConfig,
  notification_config,
  company,
  depreciations,
  handleAddCustomField,
  handleRemoveCustomField,
  handleSubmit,
  notifications_elementsBySections,
  allSections,
  handleAddToNotify,
  handleRemoveToNotify,
  handleCheckSection,
  handleCheckPermission,
  handleClickPermissionRow,

  handleValueChange,
  handleValidation,
  subcompany,
  isFetching,
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  groups, //Groups
  isSaving,
  isSubmitted,
}) => (
  <Common.Wrapper fluid={true}>
    {/* <Common.Header title={t("notification_config.title")} /> */}
    <div className="col-12">
      <Common.Portlet
        title={
          t('menu.configuration') +
          ' > ' +
          t('notification_config.title') +
          ' > ' +
          t('menu.configuration') +
          ' > ' +
          t('notification_config.title') +
          ' > ' +
          t(notificationConfig.id ? 'notification_config.edit' : 'notification_config.add')
        }
        icon={'archive'}
      >
        <NotificationConfig.Form
          notification_config={notification_config}
          company={company}
          depreciations={depreciations}
          handleAddCustomField={handleAddCustomField}
          handleRemoveCustomField={handleRemoveCustomField}
          handleSubmit={handleSubmit}
          notifications_elementsBySections={notifications_elementsBySections}
          allSections={allSections}
          handleAddToNotify={handleAddToNotify}
          handleRemoveToNotify={handleRemoveToNotify}
          handleCheckSection={handleCheckSection}
          handleCheckPermission={handleCheckPermission}
          handleClickPermissionRow={handleClickPermissionRow}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isSubmitted={isSubmitted}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={groups} //Groups
          isSaving={isSaving}
          subcompany={subcompany}
          values={notificationConfig}
        />
        <Common.LoaderOverlay show={isFetching} />
      </Common.Portlet>
    </div>
  </Common.Wrapper>
);

export default translate()(NotificationConfigFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/components/NotificationConfigFormView.js